import { render, staticRenderFns } from "./FeedNews.vue?vue&type=template&id=cf6c9066&"
import script from "./FeedNews.vue?vue&type=script&lang=js&"
export * from "./FeedNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports